/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Pending Actions.
 * @export
 */
export const ICON_PENDING_ACTIONS = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 3.5H13.82C13.4 2.34 12.3 1.5 11 1.5C9.7 1.5 8.6 2.34 8.18 3.5H5C3.9 3.5 3 4.4 3 5.5V20.5C3 21.6 3.9 22.5 5 22.5H11.11C10.52 21.93 10.04 21.25 9.69 20.5H5V5.5H7V6.5C7 7.6 7.9 8.5 9 8.5H13C14.1 8.5 15 7.6 15 6.5V5.5H17V10.58C17.71 10.68 18.38 10.89 19 11.18V5.5C19 4.4 18.1 3.5 17 3.5ZM11 5.5C10.45 5.5 10 5.05 10 4.5C10 3.95 10.45 3.5 11 3.5C11.55 3.5 12 3.95 12 4.5C12 5.05 11.55 5.5 11 5.5ZM16 12.5C13.24 12.5 11 14.74 11 17.5C11 20.26 13.24 22.5 16 22.5C18.76 22.5 21 20.26 21 17.5C21 14.74 18.76 12.5 16 12.5ZM17.29 19.5L15.64 17.85C15.55 17.76 15.49 17.63 15.49 17.5V15.01C15.49 14.73 15.71 14.51 15.99 14.51C16.27 14.51 16.49 14.73 16.49 15.01V17.3L17.99 18.8C18.19 19 18.19 19.31 17.99 19.51C17.8 19.7 17.49 19.7 17.29 19.5Z"
      fill="#707070"
    />
  </svg>
);
